import { createFileRoute } from '@tanstack/react-router'

import { LearnpathsAddElementsPlatformTopicCreate } from '@/learnpaths/components/LearnpathsAddElementsPlatformTopicCreate/LearnpathsAddElementsPlatformTopicCreate'

export const Route = createFileRoute(
  '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/create/platform-topic',
)({
  component: RouteComponent,
  validateSearch: (search: { index?: number }) => search,
})

function RouteComponent() {
  const params = Route.useParams()
  return <LearnpathsAddElementsPlatformTopicCreate {...params} />
}
